import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";

@Component({
	selector: "app-menu-item-subscription-history",
	templateUrl: "./menu-item-subscription-history.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class MenuItemSubscriptionHistoryComponent implements OnInit {
	@Input() menuItemKey: number;

	menuItem: OOMenuItem;

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.menuItem = this.venueService.ooMenuItems.find((item) => item.menuItemKey === this.menuItemKey);
	}
}
